import { useIsRestoring, useMutation, useQueries, useQuery, useQueryClient } from "@tanstack/react-query";
import api from "../api";

export const useGetPunchEntries = (params, queryparams = {}) => {
    const queryClient = useQueryClient();

    return useQuery({
        queryKey: ["punch_entries", params],
        queryFn: async () => (await api.get("/punch_entries/", { ...params })).data,
        ...queryparams
    });
};

export const usePostPunchEntry = (queryparams = {}) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (data) => (await api.post("/punchentries/", data)).data,
        mutationKey: "punch_entries",
        ...queryparams,
        onSuccess: () => {
            queryClient.invalidateQueries("punch_entries");
            queryparams.onSuccess && queryparams.onSuccess();
        },
    });

};

export const useUpdatePunchEntry = (queryparams = {}) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ id, ...data }) => (await api.patch(`/punchentries/${id}/`, data)).data,
        mutationKey: "punch_entries",
        ...queryparams,
        onSuccess: () => {
            queryClient.invalidateQueries("punch_entries");
            queryparams.onSuccess && queryparams.onSuccess();
        },
    });

}


export const useDeletePunchEntry = (queryparams = {}) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ id }) => (await api.delete(`/punchentries/${id}/`)).data,
        mutationKey: "punch_entries",
        ...queryparams,
        onSuccess: () => {
            queryClient.invalidateQueries("punch_entries");
            queryparams.onSuccess && queryparams.onSuccess();
        },
    });

}